(function () {
  'use strict';

  angular
    .module('iqxCore')
    .config($httpProviderConfig)


  function $httpProviderConfig($httpProvider) {
    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {}
    }
    //disable IE ajax caching on gets
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache'
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache'
  }

})()